import Vue from "vue"
import VueRouter from "vue-router"

import Home from "@/pages/Home"
import Login from "@/pages/Login"
import store from "@/xunwang-config/store";
const Detail = ()=> import("@/view/product/Detail")
//初始化
store.commit("user/INIT")
Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            path: "/",
            redirect: "/home"
        },{
            path: "/home",
            name: "Home",
            component: Home
        },{
            path: "/login",
            name: "Login",
            component: Login
        },{
            path: "/detail",
            name: "Detail",
            component: Detail
        }
    ]
})
router.beforeEach((to, from, next)=>{

    if(to.path === "/login"){
        next()
    }else{
        if(store.getters['user/token']){
            //已登录
            next()
        }else{
            //未登录或者登录过期
            next("/login")
        }
    }
})

export default router